/**
 * Beacon chat markdown — GFM tables, lists, code, links for assistant replies.
 */
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

interface BeaconMarkdownProps {
  children: string
  className?: string
}

export function BeaconMarkdown({ children, className = '' }: BeaconMarkdownProps) {
  return (
    <div className={`beacon-md ${className}`.trim()}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href, children: linkChildren }) => (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {linkChildren}
            </a>
          ),
          // Avoid nested <pre><pre> from default code block handling
          pre: ({ children: preChildren }) => <>{preChildren}</>,
          code: ({ className: codeClass, children: codeChildren, ...props }) => {
            const isBlock = Boolean(codeClass) || String(codeChildren).includes('\n')
            if (isBlock) {
              return (
                <pre className="beacon-md-pre">
                  <code className={codeClass} {...props}>
                    {codeChildren}
                  </code>
                </pre>
              )
            }
            return (
              <code className="beacon-md-code" {...props}>
                {codeChildren}
              </code>
            )
          },
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  )
}
